<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import { CheckCircle, MoveRight } from "lucide-svelte"
  import { signupStore } from "$app/signupstore.svelte"
  import Free from "./Free.svelte"
  import Standard from "./Standard.svelte"

  let {
    current_user,
    stripe_products,
    selected_plan_id,
    stripe_publish_key,
    ...other
  }: {
    current_user: UserType
    stripe_products: StripeProductType[]
    stripe_publish_key: string
    selected_plan_id: "free" | "standard"
  } = $props()

  signupStore.products = stripe_products
  signupStore.stripe_publish_key = stripe_publish_key
  signupStore.selectedPlan = stripe_products.find(
    (p) => p.id === selected_plan_id
  )
</script>

<Layout {current_user} {...other}>
  {#snippet features(features: string[])}
    <ul class="mt-4 space-y-2">
      {#each features as feature}
        <li class="flex items-center justify-start">
          <CheckCircle class="text-green-500 size-5" />

          <span class="ml-3 font-medium text-gray-900">{feature}</span>
        </li>
      {/each}
    </ul>
  {/snippet}
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
    <section class="max-w-3xl mx-auto lg:max-w-7xl">
      <div class="py-8 lg:py-12">
        <h2
          class="text-center text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl"
        >
          Create a New {selected_plan_id === "free" ? "Free" : "Standard"} Plan
        </h2>
        <div class="text-center font-semibold text-secondary">
          {#if selected_plan_id === "free"}
            <a
              href="/plans/new?selected_plan_id=standard"
              class="text-lwp-accent font-bold flex items-center justify-center gap-2"
            >
              Would you prefer a Plan with More Features?
              <MoveRight />
            </a>
          {:else}
            <a
              href="/plans/new?selected_plan_id=free"
              class="text-lwp-accent font-bold flex items-center justify-center gap-2"
            >
              Would you prefer a Free Plan? <MoveRight />
            </a>
          {/if}
        </div>
      </div>
    </section>

    <div class="max-w-2xl mx-auto bg-white">
      <div class="flex justify-center py-6 px-4">
        <a
          class="btn big bg-gray-200 hover:bg-gray-300 text-gray-700 inline font-bold text-center w-48 justify-center"
          href="/plans"
        >
          Cancel
        </a>
      </div>

      {#if selected_plan_id === "free"}
        <Free />
      {:else}
        <Standard />
      {/if}
    </div>
  </div>

  <style lang="css">
    #period-selector button {
      font-weight: 400;
      outline: none;
      transition: background-color 200ms ease-in-out;
    }
    #period-selector button.active {
      background-color: white;
      color: #222;
      font-weight: 700;
      z-index: 5;
    }
  </style>
</Layout>
